import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';
import type { InterstateOnChangeEvent } from '@interstate/components/InterstateEvents';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { useCustomerCardContext } from '../../CustomerFormContext';
import { kebabCase } from 'lodash';
import type { ErrorState } from '@makemydeal/dr-dash-ui-utils';

type DurationFieldProps = {
    label: string;
    field: string;
    value?: number;
    error: ErrorState;
    onChange?: (field: string, value: string) => void;
    disabled?: boolean;
};

export const DurationField = ({ label, field, value, error, onChange, disabled }: DurationFieldProps) => {
    const contextData = useCustomerCardContext();

    const handleChange = (e: InterstateOnChangeEvent<string>) => {
        if (onChange) {
            onChange(field, e.target.value);
        } else {
            contextData.handleNumberInputChange(field, e.target.value);
        }
    };

    const isDisabled = disabled ?? contextData.isLocked;

    return (
        <NumericInput
            name={field}
            displayLabel={true}
            label={label}
            value={value}
            allowDecimal={false}
            onChange={handleChange}
            disabled={isDisabled}
            hasError={Boolean(error.hasError)}
            errorMessage={error.errorMessage || ''}
            selectOnFocusSelector={featureToggleSelectors.isAutoSelectContentOnSlideOutsEnabledAfterBootstrap}
            data-testid={`customer-form-${kebabCase(field)}`}
            size="small"
        />
    );
};

export default DurationField;
